import Alpine from 'alpinejs'

document.addEventListener('alpine:init', () => {
	Alpine.store('stuck', {
		on: false,

		toggle() {
			this.on = ! this.on
		}
	})
	Alpine.store('drop', {
		open: false
	})
})